import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {ShareModule} from "@share/share.module";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {AdminParametreComponent} from "./admin-parametre.component";
import {DematModule,parametreDematRoutes} from "@components/admin/parametre/demat/demat.module";
import {DematComponent} from "@components/admin/parametre/demat/demat.component";
import {ParametreApiComponent} from "@components/admin/parametre/api/parametre-api.component";
import {ParametreApiModule,parametreApiRoutes} from "@components/admin/parametre/api/parametre-api.module";
import {ParametreAuthentificationComponent} from "@components/admin/parametre/authentification/parametre-authentification.component";
import {ParametreAuthentificationModule,parametreAuthentificationRoutes} from "@components/admin/parametre/authentification/parametre-authentification.module";
import {ParametreMobiliteModule,parametreMobiliteRoutes} from "@components/admin/parametre/mobilite/parametre-mobilite.module";
import {ParametreMobiliteComponent} from "@components/admin/parametre/mobilite/parametre-mobilite.component";
import {ParametreOrdonnanceurModule,parametreOrdonnanceurRoutes} from "@components/admin/parametre/ordonnanceur/parametre-ordonnanceur.module";
import {ParametreOrdonnanceurComponent} from "@components/admin/parametre/ordonnanceur/parametre-ordonnanceur.component";
import {ParametrePersonnalisationModule,parametrePersonnalisationRoutes} from "@components/admin/parametre/personnalisation/parametre-personnalisation.module";
import {ParametrePersonnalisationComponent} from "@components/admin/parametre/personnalisation/parametre-personnalisation.component";
import {ParametreFormulaireComponent} from "@components/admin/parametre/formulaire/parametre-formulaire.component";
import {ParametreFormulaireModule,parametreFormulaireRoutes} from "@components/admin/parametre/formulaire/parametre-formulaire.module";
import {GeolocalisationComponent} from "@components/admin/parametre/geolocalisation/geolocalisation.component";
import {GeolocalisationModule,geolocalisationRoutes} from "@components/admin/parametre/geolocalisation/geolocalisation.module";

export const adminParametreRoutes: Routes = [
	{
		path: 'API',
		component: ParametreApiComponent,
		canActivate: [AdminGuardProvider],
		children: parametreApiRoutes
	},{
		path: 'Authentification',
		component: ParametreAuthentificationComponent,
		canActivate: [AdminGuardProvider],
		children: parametreAuthentificationRoutes
	},{
		path: 'Demat',
		component: DematComponent,
		children: parametreDematRoutes,
		canActivate: [AdminGuardProvider],
	},{
		path: 'Mobilite',
		component: ParametreMobiliteComponent,
		canActivate: [AdminGuardProvider],
		children: parametreMobiliteRoutes
	},{
		path: 'Ordonnanceur',
		component: ParametreOrdonnanceurComponent,
		canActivate: [AdminGuardProvider],
		children: parametreOrdonnanceurRoutes
	},{
		path: 'Personnalisation',
		component: ParametrePersonnalisationComponent,
		canActivate: [AdminGuardProvider],
		children: parametrePersonnalisationRoutes
	},{
		path: 'Formulaire',
		component: ParametreFormulaireComponent,
		canActivate: [AdminGuardProvider],
		children: parametreFormulaireRoutes
	},{
		path: 'Geolocalisation',
		component: GeolocalisationComponent,
		canActivate: [AdminGuardProvider],
		children: geolocalisationRoutes
	},{
		path: '',
		redirectTo: 'Demat',
		pathMatch: 'full'
	},{
		path: '**',
		redirectTo: 'Demat'
	}
];

/**
 * Module du menu d'administration des paramètres.
 */
@NgModule({
	imports: [
		ShareModule,
		DematModule,
		ParametreApiModule,
		ParametreAuthentificationModule,
		ParametreMobiliteModule,
		ParametreOrdonnanceurModule,
		ParametrePersonnalisationModule,
		ParametreFormulaireModule,
		GeolocalisationModule,
	],
	declarations: [
		AdminParametreComponent
	],
	exports: [
		AdminParametreComponent
	],
	providers: []
})
export class AdminParametreModule {
}
